import { fieldSchemaDefV1 } from './fieldSchemaDef';
import { z } from 'zod';

export const createModelSchema = z.object({
  name: z.string().trim().min(1, { message: 'Name is required' }),
  schema: fieldSchemaDefV1,
  type: z.string(),
});
